import React from 'react';
import { observer } from 'mobx-react';

import Localizable from 'lib/intl/localizable';
import Styled from 'styled';
import LinkView from 'lib/ui/link-view';
import SVGIcon from 'lib/images/svg-icon/svg-icon';
import arrowRight from 'four-nets/icons/svg/icon_arrow-right.svg';
import defaultStyles from './breadcrumbs-view.scss';


export class BreadcrumbsViewModel {
    links: Link[];

    constructor({ links }: { links: Link[] }) {
        this.links = links;
    }
}

@Localizable()
@Styled(defaultStyles)
@observer
class BreadcrumbsView extends React.Component {
    render() {
        const {
            breadcrumbsViewModel,
            intl: { formatMessage },
            styles,
        } = this.props;
        const { links } = breadcrumbsViewModel;
        const { length } = links;

        const maxWidth = 280 / length;

        return (
            <div className={styles.breadcrumbs}>
                {links.map((link, index) => (
                    <span
                        className={styles.item}
                        style={{
                            maxWidth,
                        }}
                        key={link.label}
                    >
                        <span className={styles.linkWrapper}>
                            <LinkView key={link.href} link={link} className={styles.link}>
                                <span className={styles.linkLabel}>{formatMessage(link.label)}</span>
                                {index !== length - 1 ? <SVGIcon style={{image: styles.icon}} src={arrowRight} /> : null}
                            </LinkView>
                        </span>
                    </span>
                ))}
            </div>
        );
    }
}

export default BreadcrumbsView;
